module.exports = "<ng-container *ngIf=\"isCasting\">\n    <div class=\"container\">\n        <div class=\"cast-widget\" [class.active]=\"state\" aria-hidden=\"true\" (click)=\"exitChromecastMode($event)\">\n            <i class=\"icon vg-icon-cast connected\"></i> {{message}}\n        </div>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/chromcast-widget/cast-widget.template.html
// module id = 834
// module chunks = 2